import Header from "./components/Header";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import Services from "./components/Services";
import Strengths from "./components/Strengths";
import Works from "./components/Works";
import Process from "./components/Process";
import Area from "./components/Area";
import Company from "./components/Company";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { ScrollReveal } from "@/components/base/ScrollReveal";
import { ScrollToTop } from "@/components/base/ScrollToTop";
import { ScrollProgress } from "@/components/base/ScrollProgress";

const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || "https://www.wind-service0120.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "name": "株式会社Wind",
  "alternateName": "Wind",
  "description": "東京都世田谷区・目黒区、神奈川県川崎市麻生区・多摩区を中心に、原状回復工事、内装リフォーム、ハウスクリーニングまで総合的に承る地域密着の総合建設会社。スピードと丁寧な仕上げで住まいの価値を最大化します。",
  "url": siteUrl,
  "telephone": "+81-3-6379-2823",
  "email": "info@wind-service0120.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "松原3-30-10 双葉屋ビル 2F",
    "addressLocality": "世田谷区",
    "addressRegion": "東京都",
    "postalCode": "156-0043",
    "addressCountry": "JP"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "35.6663",
    "longitude": "139.6493"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Thursday", "Friday", "Saturday"],
      "opens": "09:00",
      "closes": "18:00"
    }
  ],
  "areaServed": [
    { "@type": "State", "name": "東京都" },
    { "@type": "State", "name": "神奈川県" }
  ],
  "priceRange": "お見積り",
  "foundingDate": "2018",
  "image": `${siteUrl}/vite.svg`
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-sans overflow-x-hidden">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ScrollProgress />
      <Header />
      <main role="main" aria-label="メインコンテンツ">
        <Hero />

        <ScrollReveal direction="blur">
          <Intro />
        </ScrollReveal>

        <ScrollReveal direction="up-left">
          <Services />
        </ScrollReveal>

        <ScrollReveal direction="up-right">
          <Strengths />
        </ScrollReveal>

        <ScrollReveal direction="up">
          <Works />
        </ScrollReveal>

        <ScrollReveal direction="left">
          <Process />
        </ScrollReveal>

        <ScrollReveal direction="blur">
          <Area />
        </ScrollReveal>

        <ScrollReveal direction="scale">
          <Company />
        </ScrollReveal>

        <ScrollReveal direction="up" rootMargin="0px 0px -10px 0px">
          <Contact />
        </ScrollReveal>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}